<template>
  <div>
    <PageView v-if="show" title>
      <div slot="headerContent">
        <search-robot @changeRobotId="onChangeRobotId"></search-robot>
      </div>
      <a-card :bordered="false" >
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item label="搜索条件">
                  <a-select v-model="queryParam.search_condition" placeholder="请选择" allowClear>
                    <a-select-option value="1">抽奖名称</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="搜索关键字">
                  <a-input v-model="queryParam.keywords" placeholder="请输入" />
                </a-form-item>
              </a-col>
              <!--            <a-col :md="(!advanced && 6) || 24" :sm="24">-->
              <!--              <span-->
              <!--                class="table-page-search-submitButtons"-->
              <!--                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"-->
              <!--              >-->
              <!--                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>-->
              <!--                <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>-->
              <!--                &lt;!&ndash;                <a @click="toggleAdvanced" style="margin-left: 8px">&ndash;&gt;-->
              <!--                &lt;!&ndash;                  {{ advanced ? '收起' : '展开' }}&ndash;&gt;-->
              <!--                &lt;!&ndash;                  <a-icon :type="advanced ? 'up' : 'down'" />&ndash;&gt;-->
              <!--                &lt;!&ndash;                </a>&ndash;&gt;-->
              <!--              </span>-->
              <!--            </a-col>-->
            </a-row>
          </a-form>
        </div>

        <div class="table-operator">
          <a-button type="primary" icon="plus" @click="$refs.add.show(currentRobotId)">新增抽奖</a-button>
          <a-button type="primary" icon="edit" @click="$refs.config.show(currentRobotId)">配置</a-button>
        </div>
        <s-table ref="table" :columns="columns" rowKey="id" :data="loadData" >
          <span slot="status" slot-scope="text">
            <span>
              <a-tag v-if="text == '2'" color="red">已结束</a-tag>
              <a-tag v-else-if="text == '1'" color="green">进行中</a-tag>
              <a-tag v-else-if="text == '0'" color="orange">等待开始</a-tag>
            </span>
          </span>
          <span slot="action" slot-scope="text, record">
            <a @click="$refs.edit.show(record)">编辑</a>
            <a-divider type="vertical"></a-divider>
            <a-dropdown>
              <a-menu slot="overlay">
                <a-menu-item
                  @click="handleChangeStatus(record, 1)"
                  :disabled="record.status == 1"
                >开启抽奖</a-menu-item>
                <a-menu-item @click="handleChangeStatus(record, 2)" :disabled="record.status !== 1">结束抽奖</a-menu-item>
                <a-menu-item @click="$refs.setGoods.show(record)">奖品设置</a-menu-item>
                <a-menu-item @click="$refs.url.show(currentRobotId, record.id)">获取链接</a-menu-item>
              </a-menu>
              <a>
                更多
                <a-icon type="down" />
              </a>
            </a-dropdown>
          </span>
        </s-table>
      </a-card>
      <AddLuckyModal ref="add" @ok="$refs.table.refresh()"/>
      <EditLuckyModal ref="edit" @ok="$refs.table.refresh()" />
      <ConfigModal ref="config"/>
      <SetGoodsModal ref="setGoods" />
      <H5urlModal ref="url"/>
    </PageView>
    <div v-else>
      <a-card title="验证身份">
        <a-result status="403" title="需要验证权限" sub-title="请输入验证密码">
          <template #extra>
            <div style="display: flex; align-items: center; justify-content: center">
              <div style="min-width: 100px; text-align: right">密码：</div>
              <a-input style="max-width: 300px" v-model="pwd"/>
            </div>

          </template>
        </a-result>
      </a-card>
    </div>
  </div>
</template>

<script>
import PageView from '@/layouts/PageView'
import { STable } from '@/components'
import SearchRobot from '@/views/components/SearchRobot/SearchRobot'
import { LuckyAPI } from '@/api/lucky'
import AddLuckyModal from '@/views/lucky/components/AddLuckyModal'
import EditLuckyModal from '@/views/lucky/components/EditLuckyModal'
import { to } from '@/utils/await'
import { message } from 'ant-design-vue'
import SetGoodsModal from '@/views/lucky/components/SetGoodsModal'
import ConfigModal from '@/views/lucky/components/ConfigModal'
import H5urlModal from '@/views/lucky/components/H5urlModal'

export default {
  name: 'Index',
  components: { H5urlModal, ConfigModal, SearchRobot, PageView, STable, AddLuckyModal, EditLuckyModal, SetGoodsModal },
  computed: {
    show() {
      if (this.pwd === '1472580') {
        this.$ls.set('lucky_p', this.pwd)
        return true
      }
      return false
    }
  },
  data: function() {
    return {
      currentRobotId: null,
      queryParam: {},
      pwd: this.$ls.get('lucky_p'),
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          width: 80,
          scopedSlots: { customRender: 'serial' }
        }, {
          title: '抽奖名称',
          dataIndex: 'luckydraw_name',
          width: 250,
          scopedSlots: { customRender: 'luckydraw_name' }
        }, {
          title: '状态',
          dataIndex: 'status',
          width: 80,
          scopedSlots: { customRender: 'status' }
        }, {
          title: '开始时间',
          dataIndex: 'start_time',
          width: 200,
          scopedSlots: { customRender: 'start_time' }
        }, {
          title: '结束时间',
          dataIndex: 'end_time',
          width: 200,
          scopedSlots: { customRender: 'end_time' }
        }, {
          title: '创建时间',
          dataIndex: 'create_time',
          width: 200,
          scopedSlots: { customRender: 'end_time' }
        }, {
          title: '操作',
          width: 150,
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      loadData: (params) => {
        return LuckyAPI.getList({
          ...params,
          sub_id: this.currentRobotId
        })
      }
    }
  },
  methods: {
    async handleChangeStatus({ id }, status) {
      const hide = message.loading('请稍后...')
      const [err] = await to(LuckyAPI.editLuckyStatus({
        sub_id: this.currentRobotId,
        id,
        status
      }))
      hide()
      if (!err) {
        message.success('操作成功')
        this.$refs.table.refresh()
      } else {
        message.error(err)
      }
    },
    onChangeRobotId(id) {
      this.currentRobotId = id
      if (this.$refs.table) {
        this.$refs.table.refresh(true)
      }
    }
  }
}
</script>

<style scoped>

</style>
